import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const avg = {
    addAvgtosaveService,
    listAverage,
    update,
    deleteData
};

function addAvgtosaveService(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "manageAverage/addAverage?authorization=" + json_cookie.token, data).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

function listAverage(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.get(config.API_URL + "manageAverage/listAverage/" + data.page + "/" + data.pageSize + "?authorization=" + json_cookie.token).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

function update(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "manageAverage/update/?authorization=" + json_cookie.token, data).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

function deleteData(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "manageAverage/deleteData/?authorization=" + json_cookie.token, data).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })

    })
}